<!-- 服务团队 -->
<template>
  <div class="team">
    <ul>
      <!-- 待确认的导师 -->
      <template v-if="mrTbc">
        <li v-for="item in mrTbc.mentors"
            :key="item.mentorId"
            class="animated animatedFadeIn">
          <div class="team-container">
            <div class="team-left">
              <img :src="item.avaurl || MentorAvatar"
                   alt="头像">
            </div>
            <div class="team-right">
              <h1>School Mentor 学术导师 —— {{item.mentorName}}</h1>
              <div class="team-item">
                <div>Education: {{item.mentorEducation}}</div>
                <div>Undergraduate: {{item.mentorUndergraduate}}</div>
                <div>Local time zone: {{item.mentorZone}}</div>
              </div>
              <div class="team-item">
                <p>Interesting Facts</p>
                <div v-for="(factsItem, factsIndex) in item.mentorFacts"
                     :key="factsIndex">{{factsItem}}</div>
              </div>
              <div class="team-item">
                <p>Other Success Cases</p>
                <div>
                  <pre>{{item.mentorSuccessCase}}</pre>
                </div>
              </div>
              <div class="team-btn">
                <Button type="primary"
                        style="width:96px;"
                        class="btn"
                        @click="selectHandle(mrTbc.id, item)">选择TA</Button>
              </div>
            </div>
          </div>
        </li>
      </template>
      <!-- 已匹配的导师 -->
      <li v-for="(item, index) in list.cmList"
          :key="'sm'+index"
          class="animated animatedFadeIn">
        <div class="team-container">
          <div class="team-left">
            <img :src="item.mentorInfo.avaurl || MentorAvatar"
                 alt="头像">
          </div>
          <div class="team-right">
            <h1>Career Mentor 职业导师 —— {{isallowedit? item.mentorName: desensitizedHandler(item.mentorName, 'name')}}</h1>
            <div class="team-item">
              <div>Education: {{item.mentorInfo.mentorEducation}}</div>
              <div>Undergraduate: {{item.mentorInfo.mentorUndergraduate}}</div>
              <div>Local time zone: {{item.mentorInfo.mentorZone}}</div>
              <div>Email: {{isallowedit? item.mentorEmail: desensitizedHandler(item.mentorEmail,'mail')}}</div>
              <div style="color: rgba(0, 0, 0, 0.45);">为了保证您的服务质量，请在通过邮件联系导师时，记得抄送给CD哟；</div>
            </div>
            <div class="team-item">
              <p>Interesting Facts</p>
              <div v-for="(factsItem, factsIndex) in item.mentorInfo.mentorFacts"
                   :key="factsIndex">{{factsItem}}</div>
            </div>
            <div class="team-item">
              <p>Other Success Cases</p>
              <div>
                <pre>{{item.mentorInfo.mentorSuccessCase}}</pre>
              </div>
            </div>
            <div class="team-btn" v-if="item.allocationType === 'PRE_SELECT'">
              <Button type="primary"
                      style="width:96px;"
                      class="btn"
                      @click="selectHandleChange(item.id,item.mentorName)">选择TA</Button>
            </div>
          </div>
        </div>
      </li>
      <li v-for="(item, index) in list.emList"
          :key="'em'+index"
          class="animated animatedFadeIn">
        <div class="team-container">
          <div class="team-left">
            <img :src="item.mentorInfo.avaurl || MentorAvatar"
                 alt="头像">
          </div>
          <div class="team-right">
            <h1>Editor Mentor 文笔导师 —— {{isallowedit ? item.mentorName:  desensitizedHandler(item.mentorName, 'name')}}</h1>
            <div class="team-item">
              <div>Education: {{item.mentorInfo.mentorEducation}}</div>
              <div>Undergraduate: {{item.mentorInfo.mentorUndergraduate}}</div>
              <div>Local time zone: {{item.mentorInfo.mentorZone}}</div>
              <div>Email: {{isallowedit ? item.mentorEmail:  desensitizedHandler(item.mentorEmail, 'mail')}}</div>
              <div style="color: rgba(0, 0, 0, 0.45);">为了保证您的服务质量，请在通过邮件联系导师时，记得抄送给CD哟；</div>
            </div>
            <div class="team-item">
              <p>Interesting Facts</p>
              <div v-for="(factsItem, factsIndex) in item.mentorInfo.mentorFacts"
                   :key="factsIndex">{{factsItem}}</div>
            </div>
            <div class="team-item">
              <p>Other Success Cases</p>
              <div>
                <pre>{{item.mentorInfo.mentorSuccessCase}}</pre>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li v-for="(item, index) in list.smList"
          :key="index"
          class="animated animatedFadeIn">
        <div class="team-container">
          <div class="team-left">
            <img :src="item.mentorInfo.avaurl || MentorAvatar"
                 alt="头像">
          </div>
          <div class="team-right">
            <h1>School Mentor 学术导师 —— {{isallowedit ? item.mentorName:  desensitizedHandler(item.mentorName, 'name')}}</h1>
            <div class="team-item">
              <div>Education: {{item.mentorInfo.mentorEducation}}</div>
              <div>Undergraduate: {{item.mentorInfo.mentorUndergraduate}}</div>
              <div>Local time zone: {{item.mentorInfo.mentorZone}}</div>
              <div>Email: {{isallowedit ? item.mentorEmail:  desensitizedHandler(item.mentorEmail, 'mail')}}</div>
              <div style="color: rgba(0, 0, 0, 0.45);">为了保证您的服务质量，请在通过邮件联系导师时，记得抄送给CD哟；</div>
            </div>
            <div class="team-item">
              <p>Interesting Facts</p>
              <div v-for="(factsItem, factsIndex) in item.mentorInfo.mentorFacts"
                   :key="factsIndex">{{factsItem}}</div>
            </div>
            <div class="team-item">
              <p>Other Success Cases</p>
              <div>
                <pre>{{item.mentorInfo.mentorSuccessCase}}</pre>
              </div>
            </div>
            <div class="team-btn" v-if="item.allocationType === 'PRE_SELECT'">
              <Button type="primary"
                      style="width:96px;"
                      class="btn"
                      @click="selectHandleChange(item.id,item.mentorName)">选择TA</Button>
            </div>
          </div>
        </div>
      </li>
      <li v-if="cdInfo"
          class="animated animatedFadeIn">
        <div class="team-container">
          <div class="team-left">
            <img :src="cdInfo.fileName || ZlrLogo"
                 alt="头像">
          </div>
          <div class="team-right">
            <h1>Coordinator 客户经理 —— {{cdInfo.name}}</h1>
            <div class="team-info">
              <span>手机：{{cdInfo.phone}}</span>
              <span>微信：{{cdInfo.wechat}}</span>
              <span>邮箱：{{cdInfo.email}}</span>
            </div>
            <div class="team-intro">
              客户经理是服务过程中与你合作最密切的人，可以为你提供的帮助主要包含:<br />
              不间断的答疑服务，只要遇到任何服务内容和申请方面的问题，请随时联系你的客户经理；<br />
              根据几十万条数据搭建的再来人选校云，为你制定最适合你、对今后发展最有利的选校方案；<br />
              提供网申和签证相关的答疑和指导；<br />
              在申请结束后，你的客户经理会邀请你加入再来人全球精英社群，结识中国乃至全球各领域最优秀人才；<br />
              与一群志同道合的年轻人互相学习、互相支持、一起成长。
            </div>
          </div>
        </div>
      </li>
      <li v-if="expert.num"
          class="animated animatedFadeIn">
        <div class="team-container">
          <div class="team-left">
            <img :src="ZlrLogo"
                 alt="头像">
          </div>
          <div class="team-right">
            <h1>申请支持专家 —— {{isallowedit ? expert.name : desensitizedHandler(expert.name, 'name')}}</h1>
            <div class="team-info">
              <span>邮箱：{{isallowedit ? expert.email:desensitizedHandler(expert.email, 'mail')}}</span>
            </div>
            <div class="team-intro">
              申请支持专家将为你提供贯穿申请全过程的申请便利性服务，包括：<br />
              根据你提供的素材，完成海外研究生项目申请所需的一份个人简历及三封推荐信的初稿<br />
              根据你的需求，为你注册申请专用邮箱，并与你共享邮箱账号信息<br />
              根据《辅导项目协议》中的“再来人辅导项目”，为你注册、开通“再来人辅导项目”的网申账号，并将所有账号及密码信息与你共享<br />
              为你收集汇总“再来人辅导项目”要求的文书题目、篇幅及格式要求<br />
              根据你与SM的头脑风暴，完成 “再来人辅导项目”的PS/Essay初稿<br />
              根据SM的修改建议，为你完成PS/Essay初稿的修改完善（修改次数以套餐包含的SM修改轮次为准，Classic Lite不限修改次数）<br />
              根据EM的修改建议，为你完成CV初稿的修改完善（共一份简历，共二轮修改）<br />
              为你完成 “再来人辅导项目”的网申表格预填写，你需要自己登陆网申系统检查表格填写内容后，自行在截止日期前提交申请<br />
              为你跟踪查询“再来人辅导项目”的申请状态，并第一时间与你同步任何来自学校的通知（如面试邀请等）以及录取结果<br />
              在你选定offer后，为你完成确认入读工作，申请I-20或CAS或COE<br />
              为你提供签证申请服务，包括提供签证材料清单及讲解注意事项、签证申请表格填写、签证费缴纳、面签时间预约、模拟面签辅导（如要求面签）<br />
              根据你的需求，提供体检相关指导
            </div>
          </div>
        </div>
      </li>
    </ul>
    <zlr-modal v-model="selectModal">
      <div class="team-sel">
        <p>School Mentor 学术导师 —— {{selectData.mentorName}}</p>
        <img :src="selectData.avaurl || MentorAvatar"
             alt="头像">
        <div class="btn-con">
          <Button class="close-btn"
                  @click="selectModal = false">关闭</Button>
          <Button type="primary"
                  class="sub-btn"
                  :loading="isSub"
                  @click="subHandle">选择TA</Button>
        </div>
      </div>
    </zlr-modal>
    <!-- pre确人导师弹窗 -->
    <zlr-modal v-model="selectPreModal">
      <div class="team-sel">
       <div>确认后{{preName}}将成为您的主申导师，并自动为您取消其他预选导师的匹配，确认继续该操作吗?</div>
        <div class="btn-con">
          <Button class="close-btn"
                  @click="selectPreModal = false">取消</Button>
          <Button type="primary"
                  class="sub-btn"
                  :loading="isPreSub"
                  @click="subConfirmHandle">确认</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>
<script>
// less
import './team.less'
// images
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
import ZlrLogo from '@/assets/msp.svg'
// components
import ZlrModal from '_c/modal/modal'
// api
import { getJointAll, getJointConfirmMentor } from '@/api/joint'
import { getMrTbc, getMrConfirm } from '@/api/mr'
import { getCdInfoDetail } from '@/api/cdinfo'
import { getInfoQueryTeam } from '@/api/info'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: 'team',
  mixins: [isAllowEdit],
  components: {
    ZlrModal
  },
  data () {
    return {
      MentorAvatar,
      ZlrLogo,
      list: {
        cmList: [],
        emList: [],
        smList: []
      },
      mrTbc: [],
      selectModal: false,
      selectData: {},
      isSub: false,
      cdInfo: null,
      expert: {},
      selectPreModal: false,
      isPreSub: false,
      preId: '',
      preName: ''
    }
  },
  computed: {},
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      // 获取已匹配的
      getJointAll().then(res => {
        this.list = res.data
      })
      // 获取选择导师列表
      getMrTbc().then(res => {
        this.mrTbc = res.data.model
      })
      // 获取cd信息
      getCdInfoDetail().then(res => {
        this.cdInfo = res.data.model
      })
      // 获取专家信息
      getInfoQueryTeam().then(res => {
        this.expert = res.data.expert || {}
      })
    },
    // 选择sm导师
    selectHandle (id, { mentorId, avaurl, mentorName }) {
      this.selectData = {
        id,
        mentorId,
        avaurl,
        mentorName
      }
      this.selectModal = true
    },
    // 提交信息
    subHandle () {
      this.isSub = true
      getMrConfirm({
        id: this.selectData.id,
        mentorId: this.selectData.mentorId
      }).then(res => {
        this.$zlr_message('成功选择SM导师', 'success')
        this.getList()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.selectModal = false
      })
    },
    // Pre选择导师
    selectHandleChange (id, name) {
      this.selectPreModal = true
      this.preId = id
      this.preName = name
    },
    // Pre确认选择导师
    subConfirmHandle () {
      this.isPreSub = true
      getJointConfirmMentor({ id: this.preId }).then(res => {
        this.$zlr_message('成功选择导师', 'success')
        this.getList()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.selectPreModal = false
      })
    }
  }
}
</script>

<style lang='less' scoped>
</style>
